"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathName = exports.getFullUrl = exports.eecPurchase = void 0;
var _ = require("lodash");
var Cookies = require("js-cookie");
var stage = process.env.STAGE === 'prod' ? 'prod' : 'test';
var logDomain = typeof location !== 'undefined' ? location.origin : '';
var header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
function eecPurchase(event) {
    return __awaiter(this, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof fetch !== 'undefined')) return [3, 2];
                    body = buildRequestBody(event);
                    return [4, fetch(logDomain + '/api/v0/l/e', {
                            body: JSON.stringify(body),
                            headers: header,
                            method: 'POST',
                        })];
                case 1:
                    _a.sent();
                    if (stage !== 'prod') {
                        console.info('tracking -> event: ', body);
                    }
                    _a.label = 2;
                case 2: return [2];
            }
        });
    });
}
exports.eecPurchase = eecPurchase;
function buildRequestBody(event) {
    var eec = _.find(event, ['event', 'EECpurchase']).ecommerce;
    var meta = _.find(event, ['event', 'gaVirtPath']);
    var cruises = getProduct(eec.purchase.products, 'cruise');
    var transfers = getProduct(eec.purchase.products, 'transfer');
    var insurances = getProduct(eec.purchase.products, 'insurance');
    var request = {
        documentPath: getPathName(),
        customerId: getCustomerId(),
        eventCategory: 'enhanced ecommerce',
        eventAction: 'transaction',
        bookingMain: {
            transactionId: eec.purchase.actionField.id,
            transactionRevenue: eec.purchase.actionField.revenue,
            currency: eec.currencyCode,
        },
        bookingCustom: {
            cruiseTransactionId: eec.purchase.actionField.id,
            leadPax: eec.leadPax,
            ship: eec.ship,
            priceModel: eec.priceModel,
            cruiseRevenue: eec.cruiseRev,
            agencyId: eec.dimension67,
            fullUrl: getFullUrl(),
        },
        cruiseItems: cruises.map(function (cruise) {
            return {
                productName: cruise.name,
                productId: cruise.id,
                productPrice: cruise.price,
                productBrand: cruise.brand,
                productCategory: cruise.category,
                productVariant: cruise.variant,
                productQuantity: 1,
                cruiseId: cruise.dimension31,
                departurePort: cruise.dimension34,
                arrivalPort: cruise.dimension35,
                route: cruise.dimension36,
                destination: cruise.dimension37,
                paxConfig: cruise.dimension38,
                travelDuration: cruise.dimension39,
                travelStartDate: cruise.dimension40,
                travelEndDate: cruise.dimension41,
                daysToCruise: cruise.dimension45,
                cabinCategory: cruise.dimension73,
                cabinNumberText: cruise.dimension74,
                numberOfBookedGuests: cruise.metric1,
                numberOfBookedAdults: cruise.metric2,
                numberOfBookedTeenager: cruise.metric3,
                numberOfBookedChildren: cruise.metric4,
                numberOfCabins: cruise.metric5,
            };
        }),
        transferItems: transfers.map(function (transfer) {
            return {
                productName: transfer.name,
                productPrice: transfer.price,
                productBrand: transfer.brand,
                productCategory: transfer.category,
                productQuantity: transfer.quantity,
                cruiseId: transfer.dimension31,
            };
        }),
        insuranceItems: insurances.map(function (insurance) {
            return {
                productName: insurance.name,
                productPrice: insurance.price,
                productBrand: insurance.brand,
                productCategory: insurance.category,
                productQuantity: insurance.quantity,
                cruiseId: insurance.dimension31,
            };
        }),
        userAgent: getUserAgent(),
        aidaSource: meta.aidaSource,
        userType: meta.userType,
        thirdPartyValues: {
            exactagNewUk: Cookies.get('et_uk'),
            exactagNewGk: Cookies.get('et_gk'),
        },
    };
    return request;
}
function getCustomerId() {
    var cookieValue = Cookies.get('_ga');
    var valArr = cookieValue ? cookieValue.split('.') : [];
    if (valArr.length === 4 && trackingIsAllowed()) {
        return "".concat(valArr[2], ".").concat(valArr[3]);
    }
    return '';
}
function trackingIsAllowed() {
    var cookieValue = (Cookies.get('privacy_consent') || '');
    return cookieValue.length > 'essential'.length;
}
function getUserAgent() {
    return hasWindow() ? window.navigator.userAgent : '';
}
function getFullUrl() {
    return hasWindow() ? window.location.href : '';
}
exports.getFullUrl = getFullUrl;
function hasWindow() {
    return typeof window !== 'undefined';
}
function getProduct(products, identifier) {
    return _.filter(products, ['dimension32', identifier]);
}
function getPathName() {
    return hasWindow() ? window.location.pathname : '';
}
exports.getPathName = getPathName;
//# sourceMappingURL=backend_event.js.map